import React, { createContext, useContext, useState, useEffect } from "react";
import { getDashboardStats } from "@/services/adminService";
import { useAuth } from "./AuthContext";

const OnboardingContext = createContext(null);

export const OnboardingProvider = ({ children }) => {
  const { user } = useAuth();
  const [isOnboardingComplete, setIsOnboardingComplete] = useState(false);
  const [orgSteps, setOrgSteps] = useState([]);
  const [statutoryStatus, setStatutoryStatus] = useState({});
  const [loading, setLoading] = useState(true);

  // NEW STATE
  const [canAddEmployees, setCanAddEmployees] = useState(false);

  const reloadOnboardingStatus = async () => {
    if (!user?.companyId) return;

    try {
      setLoading(true);
      const response = await getDashboardStats(user.companyId);
      const data = response.data ?? response;

      setIsOnboardingComplete(data.isOnboardingComplete);
      setOrgSteps(data.org_setup_steps || []);
      setStatutoryStatus(data.statutory_status || {});

      // --------------------------------------------------
      // NEW LOGIC — Check whether ALL steps EXCEPT employee
      // are completed.
      // --------------------------------------------------
      const allPreEmployeeStepsDone = (data.org_setup_steps || [])
        .filter((step) => step.id !== "setup.employee")
        .every((step) => step.is_completed);

      setCanAddEmployees(allPreEmployeeStepsDone);

    } catch (err) {
      console.error("Failed loading onboarding status:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(user?.companyId){
      reloadOnboardingStatus();
    }
  }, [user?.companyId]);

  return (
    <OnboardingContext.Provider
      value={{
        isOnboardingComplete,
        orgSteps,
        statutoryStatus,
        loading,
        reloadOnboardingStatus,
        canAddEmployees,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const ctx = useContext(OnboardingContext);
  if (!ctx) throw new Error("useOnboarding must be used inside OnboardingProvider");
  return ctx;
};
